import { CurrencyPipe } from "@angular/common";
import { CurrentTransactionDetails, TransactionDocument, Trigger, PROMOTION_LEVEL, PROMOTION_TYPE, TProduct, TransactionPromotion } from "./mapper-library.model";
import { NumberUtilService } from "./number-util.service";
import {AppLoggerService} from '@pmcretail/common-services/common/app-logger.service';

export class WebReturnMapperBuilderClass {
    className = "WebReturnMapperBuilderClass";
    private document: any;
    private webReturnObject: TransactionDocument = {
        id: '',
        orgCode: "",
        storeId: "",
        storeNodeId: "",
        storeNodeStructure: "",
        deviceId: "",
        terminalId: "",
        initiatingModule: "",
        export: false,
        isInStoreOrder: false,
        basket: {},
        basketSummary: {},
        baseCurrency: "",
        customer: {
            firstName: '',
            lastName: '',
            email: '',
            postCode: '',
            id: '',
            billingAddress: {},
            shippingAddress: {},

        },
        currentTransactionDetails: {} as CurrentTransactionDetails
    }
    numberUtilService: any;

    constructor(document, private currencyPipe?: CurrencyPipe) {
        if (document) {
            this.document = document;
        }
        this.numberUtilService = new NumberUtilService(currencyPipe);
    }

    WebReturnMapper() {
        this.webReturnObject['type'] = 'WEB_RETURNS';
        this.webReturnObject['datetime'] = this.getUTCDateTime(this.getText(this.document.updated_at));
        this.webReturnObject.baseCurrency = this.getText(this.document.base_currency_code);
        this.webReturnObject.storeId = this.getText(this.document.store_id);
        this.webReturnObject.subsidiaryId = '1';
        this.webReturnObject.initiatingModule = 'MAGENTO';
        this.webReturnObject.createdAt = this.getUTCDateTime(this.getText(this.document.created_at));
        this.webReturnObject.updatedAt = this.getUTCDateTime(this.getText(this.document.updated_at));
        this.webReturnObject.export = true;
        this.webReturnObject.transCompletedAt = this.getUTCDateTime(this.getText(this.document.updated_at));
        this.webReturnObject['externalTransactionId'] = this.getText(this.document.order_id);

        // customer
        this.webReturnObject['customer']['firstName'] = this.getText(this.document.customer_firstname) || '';
        this.webReturnObject['customer']['lastName'] = this.getText(this.document.customer_lastname) || '';
        this.webReturnObject['customer']['email'] = this.getText(this.document.customer_email) || '';
        this.webReturnObject['customer']['postCode'] = '';

        // Billing address
        this.webReturnObject['customer']['billingAddress']['address1'] = (this.document.billing_address && this.document.billing_address.street) ? this.getText(this.document.billing_address.street) : '';
        this.webReturnObject['customer']['billingAddress']['city'] = (this.document.billing_address && this.document.billing_address.city) ? this.getText(this.document.billing_address.city) : '';
        this.webReturnObject['customer']['billingAddress']['county'] = (this.document.billing_address && this.document.billing_address.region) ? this.getText(this.document.billing_address.region) : '';
        this.webReturnObject['customer']['billingAddress']['postCode'] = (this.document.billing_address && this.document.billing_address.postcode) ? this.getText(this.document.billing_address.postcode) : '';
        this.webReturnObject['customer']['billingAddress']['country'] = (this.document.billing_address && this.document.billing_address.country) ? this.getText(this.document.billing_address.country) : '';

        // Shipping address
        this.webReturnObject['customer']['shippingAddress']['address1'] = (this.document.shipping_address && this.document.shipping_address.street) ? this.getText(this.document.shipping_address.street) : '';
        this.webReturnObject['customer']['shippingAddress']['city'] = (this.document.shipping_address && this.document.shipping_address.city) ? this.getText(this.document.shipping_address.city) : '';
        this.webReturnObject['customer']['shippingAddress']['county'] = (this.document.shipping_address && this.document.shipping_address.region) ? this.getText(this.document.shipping_address.region) : '';
        this.webReturnObject['customer']['shippingAddress']['postCode'] = (this.document.shipping_address && this.document.shipping_address.postcode) ? this.getText(this.document.shipping_address.postcode) : '';
        this.webReturnObject['customer']['shippingAddress']['country'] = (this.document.shipping_address && this.document.shipping_address.country) ? this.getText(this.document.shipping_address.country) : '';

        // basketSummary 
        this.webReturnObject.basketSummary['discountTotal'] = Math.abs(Number(this.document.discount_amount ? this.getText(this.document.discount_amount) : 0));
        this.webReturnObject.basketSummary['VATTotal'] = Number(this.document.base_total_paid ? this.getText(this.document.base_total_paid) : 0);
        this.webReturnObject.basketSummary['saleTotal'] = Number(this.document.base_total_invoiced ? this.getText(this.document.base_total_invoiced) : 0);
        this.webReturnObject.basketSummary['basketTotal'] = Number(this.document.base_total_paid ? this.getText(this.document.base_total_paid) : 0);
        this.webReturnObject.basketSummary['totalItems'] = Number(this.document.total_qty_ordered ? this.getText(this.document.total_qty_ordered) : 0);
        this.webReturnObject.basketSummary['refundTotal'] = Number(this.document.base_total_refunded ? this.getText(this.document.base_total_refunded) : 0);

        // // basket line discount
        // this.webReturnObject.basket['lineDiscount'] = [];

        // let lineDiscount = {
        //     itemLineId: (this.document.items && this.document.items.item && this.document.items.item.item_id) ? this.getText(this.document.items.item.item_id) : 0,
        //     discountAmount: (this.document.items && this.document.items.item && this.document.items.item.discount_amount) ? Number(this.getText(this.document.items.item.discount_amount)) : 0
        // }
        // this.webReturnObject.basket['lineDiscount'].push(lineDiscount);

        // basket transaction discount
        

        // basket products 
        this.webReturnObject.basket['products'] = [];
        this.webReturnObject.basket['linePromotion']=[];
        this.webReturnObject.basket['transactionDiscount'] = [];
        this.webReturnObject.basket['transactionPromotion'] = [];

        // let transactionDiscount = {
        //     discountAmount: (this.document && this.document.discount_amount) ? Number(this.getText(this.document.discount_amount)) : 0
        // }
        // this.webReturnObject.basket['transactionDiscount'].push(transactionDiscount);


        let product : any= {};
        if (this.document.items && this.document.items.item) {
            if (this.document.items.item instanceof Array) {
                this.document.items.item.forEach((element, index) => {
                    let qty = this.getText(element.qty_ordered) ? Number(this.getText(element.qty_ordered)) : 0;
                    let refundQty = this.getText(element.qty_refunded) ? Number(this.getText(element.qty_refunded)) : 0;
                    let price = this.getText(element.price_incl_tax) ? Number(this.getText(element.price_incl_tax)) : 0;
                    product = {
                        description: (element.name) ? this.getText(element.name) : '',
                        SKU: (element.sku) ? this.getText(element.sku) : '',
                        quantity: (element.qty_ordered) ? Number(this.getText(element.qty_ordered)) : 0,
                        refundedQuantity: (element.qty_refunded) ? Number(this.getText(element.qty_refunded)) : 0,
                        //price: (element.original_price) ? Number(this.getText(element.original_price)) : 0,
                        price: price,
                        
                        itemLineId: (index + 1).toString(),
                        // totalLinePrice: (element.row_invoiced) ? Number(this.getText(element.row_invoiced)) : 0,
                        totalLinePrice: ((qty - refundQty) * price),
                    }

                    let promotionAmount = this.getText(element.discount_amount) ? Number(this.getText(element.discount_amount)) : 0;
                    let appliedIDs = this.getText(element.applied_rule_ids) ? this.getText(element.applied_rule_ids):'';

                    if (product && product.price != 0) {
                        if(promotionAmount)
                        {
                            let trigger = {} as Trigger;
                                    trigger.itemLineId = product.itemLineId;
                                    trigger.quantity = product.quantity ? product.quantity : 0;
                                    
                            let promotion  = {
                                promotionAmount:promotionAmount,
                                promotionId:appliedIDs,
                                itemLineId:product.itemLineId,
                                promotionLinePrice: product.totalLinePrice - promotionAmount,
                                trigger:trigger
                            }

                            this.webReturnObject.basket['linePromotion'].push(promotion);
                        }

                        this.webReturnObject.basket['products'].push(product);
                    }

                });
            } else {
                let qty = (this.document.items && this.document.items.item && this.document.items.item.qty_ordered) ? Number(this.getText(this.document.items.item.qty_ordered)) : 0;
                let refundQty = (this.document.items && this.document.items.item && this.document.items.item.qty_refunded) ? Number(this.getText(this.document.items.item.qty_refunded)) : 0;
                let price = (this.document.items && this.document.items.item && this.document.items.item.price_incl_tax) ? Number(this.getText(this.document.items.item.price_incl_tax)) : 0;
                product = {
                    description: (this.document.items && this.document.items.item && this.document.items.item.name) ? this.getText(this.document.items.item.name) : '',
                    SKU: (this.document.items && this.document.items.item && this.document.items.item.sku) ? this.getText(this.document.items.item.sku) : '',
                    quantity: (this.document.items && this.document.items.item && this.document.items.item.qty_ordered) ? Number(this.getText(this.document.items.item.qty_ordered)) : 0,
                    refundedQuantity: (this.document.items && this.document.items.item && this.document.items.item.qty_refunded) ? Number(this.getText(this.document.items.item.qty_refunded)) : 0,
                    // price: (this.document.items && this.document.items.item && this.document.items.item.original_price) ? Number(this.getText(this.document.items.item.original_price)) : 0,
                    price: price,

                    itemLineId: "1",
                    // totalLinePrice: (this.document.items && this.document.items.item && this.document.items.item.row_invoiced) ? Number(this.getText(this.document.items.item.row_invoiced)) : 0,
                    totalLinePrice: ((qty - refundQty) * price),
                }
                    let promotionAmount = this.getText(this.document.items.item.discount_amount) ? Number(this.getText(this.document.items.item.discount_amount)) : 0;
                    let appliedIDs = this.getText(this.document.items.item.applied_rule_ids) ? this.getText(this.document.items.item.applied_rule_ids):'';

                    if (product && product.price != 0) {
                        if(promotionAmount)
                        {
                            let trigger = {} as Trigger;
                                    trigger.itemLineId = product.itemLineId;
                                    trigger.quantity = product.quantity ? product.quantity : 0;
                                    
                            let promotion  = {
                                promotionAmount:promotionAmount,
                                promotionId:appliedIDs,
                                itemLineId:product.itemLineId,
                                promotionLinePrice: product.totalLinePrice - promotionAmount,
                                trigger:trigger
                            }

                            this.webReturnObject.basket['linePromotion'].push(promotion);
                        }

                        this.webReturnObject.basket['products'].push(product);
                    }
            }

            let couponCode = this.getText(this.document.coupon_code) ? this.getText(this.document.coupon_code) : 0;
            let appliedIDs = this.getText(this.document.applied_rule_ids) ? this.getText(this.document.applied_rule_ids):'';
            let discountDescription = this.getText(this.document.discount_description) ? this.getText(this.document.discount_description):'';

            let couponTriggerPromotions = [] as Trigger[];
            if(couponCode && appliedIDs)
            {
                let transactionPromotion = {} as TransactionPromotion;

                if(this.webReturnObject.basket['linePromotion'] && this.webReturnObject.basket['linePromotion'].length > 0)
                {
                    this.webReturnObject.basket['linePromotion'].forEach(
                        (promotion)=>{
                            if(promotion.promotionId === appliedIDs)
                            {
                                let trigger = {} as Trigger;
                                trigger.itemLineId = promotion.itemLineId;
                                trigger.quantity = promotion.trigger.quantity;
                                trigger.totalQuantity = promotion.trigger.quantity;
                                trigger.promotionAmount = promotion.promotionAmount;
                                trigger.refundedReason = couponCode;
                                trigger.refundedReasonDescription = discountDescription;
                                trigger.promotionId = promotion.promotionId;
                                couponTriggerPromotions.push(trigger);
                                this.webReturnObject.basket['linePromotion'] = this.webReturnObject.basket['linePromotion'].filter((x)=>x.itemLineId !== promotion.itemLineId);
                            }
                        }
                    );
                }

                if (couponTriggerPromotions.length > 0) {
                    transactionPromotion.displayText = couponTriggerPromotions[0].refundedReasonDescription;
                    transactionPromotion.name = couponTriggerPromotions[0].refundedReason;
                    transactionPromotion.promotionAmount = -(couponTriggerPromotions.reduce((n, { promotionAmount }) => n + promotionAmount, 0));
                    transactionPromotion.promotionId = couponTriggerPromotions[0].promotionId;
                    transactionPromotion.promotionInfo = couponTriggerPromotions[0].refundedReasonDescription;
                    transactionPromotion.couponCode = couponCode;
                    transactionPromotion.itemLineIds = [];
                    transactionPromotion.type = PROMOTION_TYPE.COUPON;
                    transactionPromotion.subLevelType = PROMOTION_LEVEL.LINE;
                    transactionPromotion.trigger = couponTriggerPromotions;
                }
                
                AppLoggerService.logDebug(this.className, "WebReturnMapper", "update LinePromotion With Coupon",transactionPromotion);
    
                if (!this.webReturnObject.basket.transactionPromotion ) {
                    this.webReturnObject.basket.transactionPromotion = [];
                }
    
                if (transactionPromotion && transactionPromotion.promotionId ) {
                this.webReturnObject.basket.transactionPromotion.push(transactionPromotion);
                }
            }

            this.updateTransactionPromotionPrtionCalc();
        }
        return this;
    }

    public validateProductItemDiscount(product: TProduct) {
        if (!product.itemDiscounts) {
            product.itemDiscounts = {
                trnDiscountsPortion: 0,
                trnPromotionsPortion: 0,
                refundPortion: 0,
            };
        }
        return product;
    }

    transactionPromotionProductPortionCalc(
        txDoc: TransactionDocument,
        promotion: TransactionPromotion
    ) {
        AppLoggerService.logDebug(this.className, "transactionPromotionProductPortionCalc",
            `trnsactionPromotion: ${JSON.stringify(
                promotion
            )}`
        );
        if (promotion.type === PROMOTION_TYPE.COUPON && promotion.subLevelType === PROMOTION_LEVEL.LINE) {
            txDoc.basket.products.forEach((product) => {
                product = this.validateProductItemDiscount(product);

                if (promotion.trigger && promotion.trigger.length > 0) {
                    promotion.trigger.forEach((t) => {
                        if (t.itemLineId === product.itemLineId.toString()) {
                            product.itemDiscounts.trnPromotionsPortion += t.promotionAmount;
                        }
                    });
                }
            });
        }
        else {
            txDoc.basket.products.forEach((product) => {
                product = this.validateProductItemDiscount(product);
                if (promotion.itemLineIds.includes(+product.itemLineId)) {
                    let discountAmount = 0;
                    if (this.document.items.item instanceof Array) {
                        const productItem = this.document.items.item.find(productItem => productItem.sku === product.SKU);
                        discountAmount = productItem.discount_amount ? +productItem.discount_amount : 0;
                    } else {
                        discountAmount = this.document.items.item.sku === product.SKU && this.document.items.item.discount_amount ?
                            +this.document.items.item.discount_amount : 0;
                    }
                    const transactionPromotionPortion = discountAmount;
                    product.itemDiscounts.trnPromotionsPortion += this.numberUtilService.trimTo2Decimal2(transactionPromotionPortion);
                }
            });
        }
        return txDoc;
    }

    updateTransactionPromotionPrtionCalc() {
        try {
            if (this.webReturnObject.basket.transactionPromotion && this.webReturnObject.basket.transactionPromotion.length > 0) {
                this.webReturnObject.basket.transactionPromotion.forEach(tr => {
                    this.transactionPromotionProductPortionCalc(this.webReturnObject, tr)
                })
            }
        } catch(error) {
            AppLoggerService.logError(this.className, "updateTransactionPromotionPrtionCalc", "updateTransactionPromotionPrtionCalc => failed:", error);
        }
    }

    deviceId(deviceId) {
        this.webReturnObject.deviceId = deviceId;
        return this;
    }

    terminalId(terminalId) {
        this.webReturnObject.terminalId = terminalId;
        return this;
    }

    orgCode(orgCode) {
        this.webReturnObject.orgCode = orgCode;
        return this;
    }

    storeId(storeId) {
        this.webReturnObject.storeId = storeId;
        return this;
    }

    storeNodeId(storeNodeId: string) {
        this.webReturnObject.storeNodeId = storeNodeId;
        return this;
    }

    storeNodeStructure(storeNodeStructure: string) {
        this.webReturnObject.storeNodeStructure = storeNodeStructure;
        return this;
    }

    docId(docId) {
        this.webReturnObject.id = docId;
        return this;
    }

    updateUserID(userID: string) {
        this.webReturnObject.userId = userID;
        return this;
    }

    updateUserName(name) {
        this.webReturnObject.userName = name;
        return this;
    }

    build() {
        return this.webReturnObject;
    }

    getText(obj) {
        if (obj && obj.text) {
            return obj.text;
        } else {
            return obj;
        }
    }

    getUTCDateTime(date) {
        if (date) {
            return new Date(date).toISOString();
        }
    }

    isInStoreOrder() {
        AppLoggerService.logDebug(this.className, "isInStoreOrder", "isInStoreOrder mapping started..."); 
        if(this.document.payment && this.document.payment.method && this.document.payment.method === 'pos_order'){
            this.webReturnObject.isInStoreOrder = true;
        }
        AppLoggerService.logDebug(this.className, "isInStoreOrder", "isInStoreOrder mapping ended...");
        return this;
    }
}
